import SliderSelector from './SliderSelector';

export default SliderSelector;
